var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"herelookup w-100"},[_c('manual-location-edit-component',{model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }